// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"62fe34bb","488":"f5fc0197","863":"06f73d30"}[chunkId] + ".chunk.js";
};